import React, { useEffect, useState } from 'react';
import Datatable from '../../components/Datatable';
import { Box } from '@mui/material';
import { useNotify } from '../../components/Datatable/NotifyProvider';
import LogFilters from '../../components/LogFilters';
import moment from "moment";
import 'moment/locale/pt-br';

export default function LogAuth() {
    const notify = useNotify();
    const [refresh, setRefresh] = useState(false);

    // Filtros: default últimos 7 dias (faz mais sentido pra falhas de auth
    // que ver tudo desde sempre — pode ser ajustado pelo operador)
    const [filters, setFilters] = useState({ preset: '7d' });
    // applied = filtros que estão de fato sendo enviados pra API (só atualiza
    // quando user pressiona Aplicar). Evita re-fetch a cada keystroke.
    const [applied, setApplied] = useState(filters);

    React.useEffect(() => {
        document.title = "IPV7 Tools - Gate Logs Fail";
    }, []);

    // Limpa keys vazias antes de mandar
    const buildExtra = (f) => {
        const out = {};
        if (f.preset && f.preset !== 'custom') out.preset = f.preset;
        if (f.preset === 'custom') {
            if (f.date_from) out.date_from = f.date_from;
            if (f.date_to)   out.date_to = f.date_to;
        }
        if (f.username) out.username = f.username;
        return out;
    };

    return (
        <Box>
            <LogFilters
                value={filters}
                onChange={setFilters}
                onApply={() => setApplied(filters)}
            />
            <Datatable
                refresh={refresh}
                handlerRefresh={() => setRefresh(!refresh)}
                title='Logs com falha de autenticação'
                endpoint='/radpostauth'
                extraFilters={buildExtra(applied)}
                options={{ search: false }}
                columns={[
                    { name: 'id', label: 'ID', options: { display: false } },
                    { name: 'username', label: 'Usuário' },
                    { name: 'password', label: 'Senha' },
                    {
                        name: 'authdate',
                        label: 'Data de Autenticação',
                        options: {
                            customBodyRender: value => <span>{moment(value).locale('pt-br').format('DD-MM-YYYY HH:mm:ss')} ({moment(value).locale('pt-br').fromNow()})</span>,
                        }
                    },
                ]}
            />
        </Box>
    );
}
